'use client';

import Icon from '@/components/ui/AppIcon';

export default function EducationHero() {
  return (
    <div className="relative bg-primary overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary to-primary-hover opacity-90" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="text-center">
          <div className="inline-flex items-center justify-center p-3 bg-white/10 rounded-full mb-6 ring-1 ring-white/20">
            <Icon name="AcademicCapIcon" size={32} className="text-white" />
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white tracking-tight mb-6">
            Car Care 101
          </h1>
          <p className="max-w-2xl mx-auto text-lg md:text-xl text-white/90 font-body">
            Demystify car maintenance. Learn what your car actually needs, avoid unnecessary upsells, and make smart decisions for your vehicle's health.
          </p>
        </div>
      </div>
    </div>
  );
}
